
define('tmpl!core/templates/webidl-contiguous/typedef.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlTypedef\' id=\'{{obj.idlId}}\' data-idl data-title=\'{{obj.name}}\'>typedef {{typeExtAttrs obj\n}}<span class=\'idlTypedefType\'>{{idlType obj\n}}</span> <span class=\'idlTypedefID\'>{{#tryLink obj}}{{obj.name}}{{/tryLink}}</span>;</span>');});

